import { createSlice } from '@reduxjs/toolkit';
const InitialState = {
    showMailClassifyModal: false,
    modalAccount: '',
    modalType: 'list',
    isClassifyList: true,
    mailNotice: 1,
    mailFolderId: '',
    mailSender: '',
    mailTitle: '',
    mailTag: '',
    showFolderSelectModal: false,
    isScopeSent: false,
    folderExecFun: null,
    selectedFolders: undefined,
    recent100: {
        senders: [],
        receivers: [],
        ccs: [],
        receiverAndCcs: [],
        contacts: [],
    },
};
const mailClassifySlice = createSlice({
    name: 'mailClassifyReducer',
    initialState: InitialState,
    reducers: {
        changeShowClassifyModal: (state, action) => {
            state.showMailClassifyModal = action.payload;
        },
        setModalAccount: (state, action) => {
            state.modalAccount = action.payload;
        },
        setModalType: (state, action) => {
            state.modalType = action.payload;
        },
        setIsClassifyList: (state, action) => {
            state.isClassifyList = action.payload;
        },
        setMailNotice: state => {
            state.showMailClassifyModal = true;
            state.mailNotice = Math.random();
        },
        setMailFolderId: (state, action) => {
            state.mailFolderId = action.payload;
        },
        setMailSender: (state, action) => {
            state.mailSender = action.payload;
        },
        setMailTitle: (state, action) => {
            state.mailTitle = action.payload;
        },
        setMailTag: (state, action) => {
            state.mailTag = action.payload;
        },
        setShowFolderSelectModal: (state, action) => {
            state.showFolderSelectModal = action.payload;
        },
        setIsScopeSent: (state, action) => {
            state.isScopeSent = action.payload;
        },
        setSelectedFolders: (state, action) => {
            state.selectedFolders = action.payload;
        },
        setFolderExecFun: (state, action) => {
            state.folderExecFun = action.payload;
        },
        setRecent100: (state, action) => {
            state.recent100 = action.payload;
        },
    },
});
export const { actions } = mailClassifySlice;
export default mailClassifySlice.reducer;
